import styled from "styled-components";
import { hexToRGB } from "@shared/utils/misc";
import Form from "common/Form/Form.tsx";

export const DiscountTag = styled.div<{ $isPromoCode?: boolean }>`
  padding: 6px 16px;
  border-radius: 4px;
  width: fit-content;
  color: ${(p) =>
    p.$isPromoCode ? p.theme.colors.green : p.theme.colors.primaryBlue};
  background-color: ${(p) =>
    hexToRGB(
      p.$isPromoCode ? p.theme.colors.green : p.theme.colors.primaryBlue,
      0.09
    )};
  font-size: ${(p) => p.theme.typography.fontSizes.S};
  font-weight: ${(p) => p.theme.typography.fontWeights.MEDIUM};
`;

export const CheckoutForm = styled(Form)`
  .ant-form-item-margin-offset {
    margin-bottom: -12px !important;
  }
  .ant-form-item-label > label {
    color: ${(p) => p.theme.colors.primaryText} !important;
    width: 100%;
    &::after {
      display: none;
    }
  }
`;
